// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__OZWYk","logoWrapper":"Loader_logoWrapper__2SSV6","logo":"Loader_logo__DHuPR","progressLine":"Loader_progressLine__GDICF"};